/**
 * Convert a free-form title to a kebab-case URL slug. Matches the
 * slug shape the pipeline writes on `pieces.slug` (FEAT-003 W2).
 */
export function toSlug(input: string): string {
  return input
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "") // strip diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}
